import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { fetchSiteMedia } from '../services/api';

const AboutPreview = () => {
  const { language, t } = useLanguage();
  const [imgUrl, setImgUrl] = useState('/about-story.jpg');

  const values = [1, 2, 3].map((i) => ({
    title: t(`about.value${i}.title`),
    description: t(`about.value${i}.description`),
  }));

  useEffect(() => {
    fetchSiteMedia().then((m) => {
      if (m && m.about_story) setImgUrl(m.about_story);
    });
  }, []);

  return (
    <section className="py-24 lg:py-32 bg-[#f6f5e8]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left - Image */}
          <div className="relative aspect-square lg:aspect-[4/5] overflow-hidden">
            <img
              src={imgUrl}
              alt="Altınzade Craftsmanship"
              className="w-full h-full object-cover"
            />
            {/* Decorative Border */}
            <div className="absolute inset-4 border border-[#b8860b]/30 pointer-events-none" />
          </div>

          {/* Right - Content */}
          <div>
            <span className="text-[#b8860b] text-sm font-medium tracking-widest uppercase mb-4 block">
              {t('about.subtitle')}
            </span>
            <h2 className="text-3xl md:text-4xl font-light text-[#333333] mb-8 tracking-wide leading-tight">
              {t('about.title')}
            </h2>
            <p className="text-[#666666] text-base leading-relaxed mb-12">
              {t('about.description')}
            </p>

            {/* Values */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
              {values.map((value, index) => (
                <div key={index} className="text-center sm:text-left">
                  <h4 className="text-[#333333] text-lg font-medium mb-2">
                    {value.title}
                  </h4>
                  <p className="text-[#666666] text-sm leading-relaxed">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
